import { Item } from './Autocomplete';

export const buildItem = <T extends object | string>(extractor: (element: T) => Item, elements: T[]) => {
  return elements.map((element) => extractor(element));
};
